import { render, staticRenderFns } from "./ProductExtraGroup.vue?vue&type=template&id=a7cc5992"
import script from "./ProductExtraGroup.vue?vue&type=script&lang=js"
export * from "./ProductExtraGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports